import { render } from "./ContactProfileMultiItemInfo.vue?vue&type=template&id=24dc095c"
import script from "./ContactProfileMultiItemInfo.vue?vue&type=script&lang=js"
export * from "./ContactProfileMultiItemInfo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__